<template>
  <v-flex md3 px-2 class="text-xs-center">
    <div class="v-responsive v-image elevation-6" style="width: 180px;margin: 0 auto 3rem">
      <div class="v-responsive__sizer" style="padding-bottom: 100%;"></div>

      <v-img v-if="imageUrl" :src="imageUrl"></v-img>
    </div>

    <p class="display-1 font-weight-light">{{ profile.firstName }} {{ profile.lastName }}</p>

    <v-btn round large depressed dark color="teal" :to="{name: 'edit'}">EDYCJA</v-btn>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';
import { sharedConfig } from '@witkac/kartamiejska-shared';

import { config } from '@/utils/config';

// @vuese
// Informacja o zalogowanym użytkowniku
// @group Components
export default {
  computed: mapState({
    profile: state => state.profile.data,
    imageUrl: state =>
      state.profile.data.mainImage &&
      `${config.mediaURL}/${state.profile.data.mainImage}?${sharedConfig.sizes.avatar.medium.queryString}`
  })
};
</script>
